<div>
    <ng-template #dynamicTarget></ng-template>
</div>
